import { Alert, Snackbar } from '@mui/material';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useResponseHandlerService } from '../../services';

const ResponseResultAlert: FunctionComponent = () => {
	const {
		error,
		success,
		showTime,
		addSuccess: setSuccess,
		addError: setError,
	} = useResponseHandlerService();
	const [open, setOpen] = useState<boolean>(false);
	useEffect(() => {
		setOpen(true);
	}, [error, success]);

	const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
		if (reason === 'clickaway') {
			return;
		}
		setError(undefined);
		setSuccess(undefined);
		setOpen(false);
	};
	return (
		<Snackbar
			open={open}
			autoHideDuration={showTime}
			onClose={handleClose}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
		>
			<div>
				{error && (
					<Alert severity="error" sx={{ width: '100%' }}>
						{error.message}
					</Alert>
				)}
				{success && (
					<Alert severity="success" sx={{ width: '100%' }}>
						{success}
					</Alert>
				)}
			</div>
		</Snackbar>
	);
};

export default ResponseResultAlert;
